import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation removeProcessingUser($username: String!) {
      deleteProcessingUser(username: $username) {
        success
      }
    }
  `,
  mutationName: "removeProcessingUser",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingUser/removeProcessingUser.js